import React from 'react';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';
import { useLocation, useNavigate } from 'react-router-dom';

import AboutData from './AboutData';
import FaqData from './FaqData';
import PolicyCostData from './PolicyCostData';
import PurchasingProcessData from './PurchasingProcessData';
import ProductCarriers from './ProductCarriers';
import WholeLifeArticleData from './WholeLifeArticleData';
import WholeLifeAboutMeForm from '../../../../Quoters/WholeLife/steps/AboutMeForm';
import { getPrimaryColor } from '../../../../Quoters/Common/Helpers/Utility';

export default function WholeLifeData(props) {
  const primaryBrandColor = getPrimaryColor();
  const minAgeDays = 14;
  const minAge = 0;
  const maxAge = 80;
  const minCoverageAmount = 10000;
  const maxCoverageAmount = 10000000;
  const teaserQuoteParams = {
    faceAmount: 20000,
    termLength: "Lifetime Pay",
  };
  
  const navigate = useNavigate();
  const location = useLocation();
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  const accountProductTypeSettings = accountObj.accountProducts.find(product => product.productLandingUrl === location.pathname);
  const accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ?
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;

  const wholeLifeForm = (<WholeLifeAboutMeForm
    ageSpecs={{ minAgeDays: minAgeDays, min: minAge, max: maxAge }}
    onNext={() => {
      navigate('/whole-life/select-appointment');
    }}
    brandTheme={primaryBrandColor}
    showHeader={false}
    submitButtonVariant={'landing'}
    isWholeLife={props.isWholeLife}
    teaserQuoteParams={teaserQuoteParams}
    ref={props.aboutMeFormRef}
  />);

  const defaultValueProposition = [{
    title: " Whole Life Insurance",
    subtitle: "Lifetime Protection",
    subtitleExtended: "Affordable coverage from top rated companies."
  }];

  return {
    name: 'Whole Life Insurance',
    subtitle: 'Lifetime Protection - Today',
    footerMessage: "Get peace of mind and whole life insurance",
    footerButtonName: "Continue",
    heroText: accountLandingOverride ? JSON.parse(accountLandingOverride.valueProposition) : defaultValueProposition,
    basicInfoForm: () => {
      return wholeLifeForm;
    },
    about: AboutData(minAgeDays, maxAge, minCoverageAmount, maxCoverageAmount),
    purchasingProcess: PurchasingProcessData(),
    policyCost: PolicyCostData(),
    faq: FaqData(),
    termArticle: WholeLifeArticleData(),
    productCarriers: ProductCarriers(),
    isAddDefaultFaq: false,
  };
}
